module.exports = __webpack_public_path__ + "static/media/house-2.9570b199.jpg";